import React, { Component } from 'react';
import { Button, Dialog, DialogContent, DialogActions, Grid, IconButton, withStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import axios from 'axios';
import { BBS_API_URL, EVENT_ID } from '../../constants';
const moment = require('moment');

const Accordion = withStyles({
  root: {
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles((theme) => ({
  root: {
    backgroundColor: 'rgba(0, 0, 0, .03)',
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56,
    },
  },
  content: {
    [theme.breakpoints.down('sm')]: {
      margin: '6px 0',
    },
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
}))(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiAccordionDetails);

const styles = (theme) => ({
  dialogRoot: {
    minWidth: 'lg',
    '& .MuiDialog-container': {
      // height: '110%',
    },
    '& .MuiDialog-paper': {
      height: '80vh',
    },
    '& table': {
      width: '100%',
      borderCollapse: 'collapse',
      [theme.breakpoints.down('sm')]: {
        fontSize: '12px',
      },
    },
    '& td': {
      border: '1px solid dimgray',
      padding: '4px',
      background: 'white',
    },
    '& tr': {
      '&:first-child': {
        '& td': {
          backgroundColor: `${theme.palette.primary.bg} !important`,
          fontWeight: 'bold',
        },
      },
    },
  },

  contentGrid: {
    backgroundColor: '#f9f9f9',
    minHeight: '80vh',
    padding: '24px',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },

  listTitle: {
    fontSize: '19.5px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '3.03',
    letterSpacing: '-0.68px',
    textAlign: 'left',
    color: theme.palette.primary.main,
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
      lineHeight: '2',
      marginTop: '20px',
    },
  },

  listNumber: {
    fontSize: '23px',
    fontWeight: 'bold',
    fontStyle: 'normal',
    lineHeight: '2.02',
    letterSpacing: '-0.81px',
    textAlign: 'center',
    // color: theme.palette.secondary.main,
    color: theme.palette.primary.main,
  },

  listItem: {
    backgroundColor: '#ffffff',
    '&:hover': {
      '& $listPrimaryMob': {
        color: theme.palette.primary.main,
      },
      backgroundColor: '#f6fffc',
    },
  },
  listBorder: {
    borderTop: `2px solid ${theme.palette.primary.main}`,
  },
  // 공지리스트 제목
  titleDiv: {
    display: 'flex',
    alignItems: 'center',
  },
  listPrimaryMob: {
    fontSize: '15.5px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    /* lineHeight: '3', */
    letterSpacing: '-0.54px',
    textAlign: 'left',
    color: '#000000',
    margin: '0px 0px 0px 20px',
    [theme.breakpoints.down('sm')]: {
      margin: '0px 0px 0px 10px',
    },
  },
  listSecondaryMob: {
    fontSize: '12.5px',
    fontStretch: 'normal',
    fontStyle: 'normal',
    letterSpacing: '-0.54px',
    textAlign: 'left',
    color: '#4e4e4e',
    margin: '0px 0px 0px 20px',
    [theme.breakpoints.down('sm')]: {
      margin: '0px 0px 0px 10px',
    },
  },
  mobResponsive: {
    padding: '10px',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  mobileNoticeContent: {
    width: '100%',
    maxWidth: '100%',
    '& table': {
      width: '100% !important',
      marginLeft: '0 !important',
    },
  },
  closeBtn: {
    right: '10px',
    color: '#5b5b5b',
    top: '10px',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },

  listGrid: {
    padding: '20px',
    [theme.breakpoints.down('sm')]: {
      padding: '0px 10px 10px 10px',
    },
  },

  contentTopPadding: {
    paddingTop: '35px,',
  },

  dialogActions: {
    display: 'none',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  contentTitle: {
    fontSize: '23px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '2.02',
    letterSpacing: '-0.81px',
    textAlign: 'left',
    color: theme.palette.primary.main,
  },
});

class NoticeDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      noticeData: [],
      selected: 0,
    };
  }

  componentDidMount() {
    axios.get(`${BBS_API_URL}/notice/list?eventId=${EVENT_ID}&limit=-1`, { headers: { Pragma: 'no-cache' } }).then((response) => {
      // console.log(response.data.Items);
      response.data.Items.sort((a, b) => {
        return Number(a.sortOrder) > Number(b.sortOrder) ? 1 : -1;
      });

      this.setState({ noticeData: response.data.Items });
    });
  }

  viewList(value, idx) {
    console.log(value);
    this.setState({ selected: idx });
  }

  render() {
    const { classes, open, onClose } = this.props;
    const arrayLength = this.state.noticeData.length;

    const noticePopup = (datas) => {
      datas = this.state.noticeData;
      return datas.map((notiCate, i) => {
        return (
          <Accordion
            key={i}
            expanded={this.state.selected === i ? true : false}
            onClick={(event) => {
              this.viewList(notiCate, i);
            }}
          >
            <AccordionSummary className={classes.listItem}>
              <Grid container direction="row" justifyContent="flex-start" alignItems="center">
                <div className={classes.listNumber}>{i < 10 ? '0' + (i + 1) : i + 1}.</div>
                <Grid item>
                  <Grid container direction="column" justifyContent="flex-start" alignItems="flex-start">
                    <div className={classes.titleDiv}>
                      <p className={classes.listPrimaryMob} dangerouslySetInnerHTML={{ __html: notiCate.noticeTitle }} />
                    </div>
                    <div className={classes.listSecondaryMob}>{moment(Number(notiCate.createdAt)).format('YYYY-MM-DD')}</div>
                  </Grid>
                </Grid>
              </Grid>
            </AccordionSummary>
            <AccordionDetails className={classes.mobResponsive}>
              <Grid container>
                <div className={classes.mobileNoticeContent} dangerouslySetInnerHTML={{ __html: notiCate.noticeContents }} />
              </Grid>
            </AccordionDetails>
          </Accordion>
        );
      });
    };
    return (
      <Dialog
        fullWidth={true}
        maxWidth={'lg'}
        onClose={onClose}
        aria-labelledby="faq-dialog-title"
        open={open}
        // disableBackdropClick={disableBackdrop}
        // disableEscapeKeyDown={disableBackdrop}
        className={classes.dialogRoot}
      >
        <DialogContent style={{ padding: '0px' }}>
          <Grid container>
            <Grid item xs={12} sm={12} md={4} className={classes.listGrid}>
              <Grid>
                {/* <div className={classes.listTitle}>Notice List</div> */}
                <div className={classes.listTitle}>Event</div>
                <Grid>
                  <div align="right">
                    <p style={{ display: 'inline-block' }}> Total</p>
                    <p style={{ display: 'inline-block', color: '#d54a50' }}>&nbsp;{arrayLength}</p>
                  </div>
                </Grid>
              </Grid>
              <Grid className={classes.listBorder}>
                <div>{noticePopup(this.state.notiCate)}</div>
              </Grid>
            </Grid>
            {this.state.noticeData.length > 0 ? (
              <Grid item xs={false} sm={false} md={8} className={classes.contentGrid}>
                <Grid container>
                  <Grid container style={{ borderBottom: '1px solid #e4e4e4', padding: '20px 40px 20px 20px ' }}>
                    <div className={classes.contentTitle}>
                      <div dangerouslySetInnerHTML={{ __html: this.state.noticeData[this.state.selected].noticeTitle }} />

                      <IconButton onClick={onClose} className={classes.closeBtn} style={{ position: 'absolute' }}>
                        <CloseIcon />
                      </IconButton>
                    </div>
                  </Grid>
                  <Grid container className={classes.contentTopPadding}>
                    <div
                      style={{ maxWidth: this.state.matches ? '100%' : '' }}
                      dangerouslySetInnerHTML={{ __html: this.state.noticeData[this.state.selected].noticeContents }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            ) : (
              ''
            )}
          </Grid>
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <div>
            <Button onClick={onClose} style={{ color: '#000000', fontSize: '18px', fontWeight: '600' }}>
              닫기
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withStyles(styles, { withTheme: true })(NoticeDialog);
